define( [
	"../../core",
	"../../selector"
], function( jQuery ) {
	return jQuery.expr.match.needsContext;
} );



//////////////////
// WEBPACK FOOTER
// /~/jquery/src/traversing/var/rneedsContext.js
// module id = 878
// module chunks = 0